import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

const COOKIE_BANNER_CATEGORY = 'cookie_banner';

export const SP_COOKIE_BANNER_EVENTS = {
  ACCEPT_ALL_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: COOKIE_BANNER_CATEGORY,
    name: 'accept_all',
  }),
  ESSENTIAL_ONLY_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: COOKIE_BANNER_CATEGORY,
    name: 'essential_only',
  }),
  LEARN_MORE_CLICKED: (url: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: COOKIE_BANNER_CATEGORY,
    name: 'learn_more',
    url,
  }),
  LOADED: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: COOKIE_BANNER_CATEGORY,
    name: 'cookie_banner_loaded',
  }),
};
